export default __webpack_public_path__ + "static/media/logo_1_eng_2_0.40914598.png";